import { tag } from "brandi";

export const TAGS = {
    offline: tag('offline')
}
